module.exports = __webpack_public_path__ + "static/media/belasting-6.5cdddaa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-6.svg
// module id = 90
// module chunks = 0